import * as React from 'react';
import { IMagazinePageSection } from 'models/common/section';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { Link } from 'react-router';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { formatInteger } from '../../../../../../helpers/common';

require('./style.css');

interface IProps {
	section: IMagazinePageSection;
	t?: (key: string, options?: any) => string;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ViewType4 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { elements } = this.props.section.data;
		const { t } = this.props;

		return (
			<div className="container sectionType4container">
				<div className="row">
					<div className="col-md-12 no_pad">
						<div className="titleHigh">
							<Link to={(elements[12] as ISectionTextElement).redirectUrl}>
								{(elements[12] as ISectionTextElement).text}
							</Link>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-3 no_pad">
						<Link className="highlightedArticle border" to={(elements[0] as ISectionTextElement).redirectUrl}>
							<div className="author">
								<span className="byText">{t('Magazine_Section_Common_By')} </span>
								<span className="text">{(elements[1] as ISectionTextElement).text}</span>
							</div>
							<div className="titleArticle">{(elements[0] as ISectionTextElement).text}</div>
							<div className="time">
								{t('BSPortal_Common_MinsRead', {
									count: formatInteger(parseInt((elements[2] as ISectionTextElement).text, 10)),
								})}
							</div>
						</Link>
					</div>
					<div className="col-lg-3 no_pad">
						<Link className="highlightedArticle border" to={(elements[3] as ISectionTextElement).redirectUrl}>
							<div className="author">
								<span className="byText">{t('Magazine_Section_Common_By')} </span>
								<span className="text">{(elements[4] as ISectionTextElement).text}</span>
							</div>
							<div className="titleArticle">{(elements[3] as ISectionTextElement).text}</div>
							<div className="time">
								{t('BSPortal_Common_MinsRead', {
									count: formatInteger(parseInt((elements[5] as ISectionTextElement).text, 10)),
								})}
							</div>
						</Link>
					</div>
					<div className="col-lg-3 no_pad">
						<Link className="highlightedArticle border" to={(elements[6] as ISectionTextElement).redirectUrl}>
							<div className="author">
								<span className="byText">{t('Magazine_Section_Common_By')} </span>
								<span className="text">{(elements[7] as ISectionTextElement).text}</span>
							</div>
							<div className="titleArticle">{(elements[6] as ISectionTextElement).text}</div>
							<div className="time">
								{t('BSPortal_Common_MinsRead', {
									count: formatInteger(parseInt((elements[8] as ISectionTextElement).text, 10)),
								})}
							</div>
						</Link>
					</div>
					<div className="col-lg-3 no_pad">
						<Link className="highlightedArticle" to={(elements[9] as ISectionTextElement).redirectUrl}>
							<div className="author">
								<span className="byText">{t('Magazine_Section_Common_By')} </span>
								<span className="text">{(elements[10] as ISectionTextElement).text}</span>
							</div>
							<div className="titleArticle">{(elements[9] as ISectionTextElement).text}</div>
							<div className="time">
								{t('BSPortal_Common_MinsRead', {
									count: formatInteger(parseInt((elements[11] as ISectionTextElement).text, 10)),
								})}
							</div>
						</Link>
					</div>
				</div>
			</div>
		);
	}
}

export { ViewType4 };
